export default "__VITE_ASSET__6bbece32__"